import React from "react";
var __jsx = React.createElement;
import { statusIntent, humanizeStatus } from "@/utils/patient-format";
import { statusPillClasses } from "./status-pill-intent";
/** A status pill with a leading dot, coloured by the EMR status semantic. */
export function StatusPill(_ref) {
  var status = _ref.status;
  return /*#__PURE__*/React.createElement("span", {
    className: "inline-flex w-fit items-center gap-2 rounded-sds-full border px-3 py-1 text-style-label-emphasis ".concat(statusPillClasses(statusIntent(status)))
  }, /*#__PURE__*/React.createElement("span", {
    className: "h-1.5 w-1.5 rounded-full bg-current"
  }), humanizeStatus(status));
}